import React, { Component } from 'react';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import CheckBoxField from '../../Feeds/AddFeeds/Elements/CheckboxField';
import { Image, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { deleteAutoModRule } from '../../../../../actions/appsMoreAction';
import moment from 'moment';
import HttpClient from '../../../../../actions/http-client';
import { UPDATE_AUTOMOD_INDEX } from '../../../../../actions/api';
import { SWAL_FIRE, TOAST_SUCCESS, baseUrl, getInitialRoute } from '../../../../../utils';
import { FontAwesomeIcon } from '../../../../CommonComponents/AssetsHelper';

class AutoModerationSidebar extends Component {

    getItemStyle = (isDragging, draggableStyle) => ({
        userSelect: "none",
        margin: `0 0 8px 0`,
        background: "none",
        ...draggableStyle
    });

    reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    }

    onDragEnd = (result) => {
        if (!result.destination) return;
        const { changeRuleOrder, createdRules } = this.props;

        const itemsNew = this.reorder(createdRules, result.source.index, result.destination.index);

        if (itemsNew.length > 1) {
            const payload = itemsNew.map((item, index) => ({ [item.id]: index }));
            changeRuleOrder(itemsNew);
            this.updateRulesIndex(payload).then(() => {
                TOAST_SUCCESS('Rule Order Successfully Updated')
            }).catch(ex => { });
        }
    }
    deleteCreatedRule = (id, index) => {
        SWAL_FIRE({
            title: "Are you sure?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
            confirmButtonColor: "#FF4051",
            cancelButtonColor: "#E4E6EF",
            cancelButtonText: "No",
        }).then((result) => {
            if (result.value) {
                const toastID = toast.loading("Loading...", { autoClose: 3000 })
                deleteAutoModRule(id).then(res => {
                    const { message, status } = res.data
                    const type = toast.TYPE.SUCCESS;
                    if (status) {
                        this.props.removeRule();
                    } else {
                        type = toast.TYPE.ERROR;
                    }
                    toast.update(toastID, {
                        render: message,
                        type: type,
                        autoClose: 3000
                    })
                    setTimeout(() => toast.dismiss(toastID), 3000);
                }).catch(ex => {
                    setTimeout(() => toast.dismiss(toastID), 3000);
                })
            } else if (result.dismiss === "cancel") {
            }
        });
    }

    updateRuleStatus = (id, index, status) => {
        this.props.updateCreatedRule(id, index, status);
    }

    updateRulesIndex = (rulesArr) => {
        return new HttpClient().post(`${UPDATE_AUTOMOD_INDEX}`, { rulesArr, wallId: localStorage.getItem('wallId') });
    }

    render() {
        const { defaultRules, selectDefaultRule, createdRules, updateRule, ruleId, trueSenseEnable, upgradePlan } = this.props;

        return <div className="moderation_modal_action_right border-start">
            <div className="moderation-right p-3">
                <div className="">
                    <h6 className="border-bottom mb-3 pb-3">Here's all that you can do:</h6>
                    {!ruleId && createdRules.length > 0 ?
                        <div className="mb-3 table-responsive">
                            <table className="table table-lg align-middle gs-0 gy-3 my-0 pb-2">
                                <thead className="thead-light">
                                    <tr>
                                        <th className="fw-bold text-nowrap" style={{ minWidth: 3 }}></th>
                                        <th className="fw-bold text-nowrap" style={{ minWidth: 3 }}>Priority</th>
                                        <th className="fw-bold text-nowrap" style={{ minWidth: 60 }}>Rule Name</th>
                                        <th className="fw-bold text-nowrap" style={{ minWidth: 60 }}>Status</th>
                                        <th className="fw-bold text-nowrap" style={{ minWidth: 40 }}>Last Executed</th>
                                        <th className="fw-bold text-nowrap text-end" style={{ minWidth: 40 }}>Actions</th>
                                    </tr>
                                </thead>
                                <DragDropContext onDragEnd={this.onDragEnd} style={{ background: 'none', width: '100%' }} className={'test'}>
                                    <Droppable droppableId="droppableScenes" style={{ background: 'none', width: '100%' }}>
                                        {(provided, snapshot) => (
                                            <tbody {...provided.droppableProps} ref={provided.innerRef} style={{ background: 'none', width: '100%' }}>
                                                {createdRules.map((rItem, rIndex) => {
                                                    return <Draggable key={rItem.id} draggableId={`draggableId${rItem.id}`} index={rIndex}>
                                                        {(provided, snapshot) => (
                                                            <tr className='position-static' ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}
                                                                style={this.getItemStyle(snapshot.isDragging, provided.draggableProps.style)}>
                                                                <td>
                                                                    <div className="pointer d-flex aling-items-center">
                                                                        {[...Array(2)].map((item, index) => <div className="" key={index}>
                                                                            {[...Array(4)].map((item, index) => <span key={index}></span>)}
                                                                        </div>)}
                                                                    </div>
                                                                </td>
                                                                <td>{rIndex + 1}</td>
                                                                <td>
                                                                    <div className="overflow-hidden">
                                                                        <span className="d-block text-ellipsis m-auto" style={{ maxWidth: 100 }}>{rItem.name ? rItem.name : 'Rule'}</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <label className="switch custom-toggle justify-content-center">
                                                                        <CheckBoxField isChecked={rItem.status == 1 ? true : false} name={`option-${rIndex}`} id={`option-${rIndex}`} onChangeHandler={(e) => this.updateRuleStatus(rItem.id, rIndex, !rItem.status)} text={''} />
                                                                    </label>
                                                                </td>
                                                                <td>
                                                                    <div className="overflow-hidden d-flex justify-content-center">
                                                                        <OverlayTrigger placement="top" overlay={rItem.lastExcuated ? <Tooltip>{`${rItem.postCount ? rItem.postCount : 0} post${rItem.postCount ? rItem.postCount > 1 ? 's' : '' : ''} status updated`}</Tooltip> : <></>}>
                                                                            <span className="d-block text-ellipsis m-auto" style={{ maxWidth: 100 }}>{rItem.lastExcuated ? moment(new Date(rItem.lastExcuated * 1000)).fromNow() : '--'}</span>
                                                                        </OverlayTrigger>
                                                                    </div>
                                                                </td>
                                                                <td className="pr-0 text-end px-1">
                                                                    <div className="d-flex align-items-center justify-content-end">
                                                                        {(rItem.actions && isNaN(rItem.actions)) ? <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>}>
                                                                            <button type="button" className="btn btn-link btn-active-light btn-active-color-primary p-0 w-32px h-32px transition-none border-0" onClick={() => updateRule(rItem)}>
                                                                                <Image src={baseUrl('icons/svg-icons/edit.svg')} height="16" width="16" />
                                                                            </button>
                                                                        </OverlayTrigger> : null}
                                                                        <OverlayTrigger placement="top" overlay={<Tooltip>Remove</Tooltip>}>
                                                                            <button type="button" className="btn btn-link btn-active-light btn-active-color-primary p-0 w-32px h-32px transition-none border-0" onClick={() => this.deleteCreatedRule(rItem.id, rIndex)}>
                                                                                <Image src={baseUrl('icons/svg-icons/delete.svg')} height="16" width="16" />
                                                                            </button>
                                                                        </OverlayTrigger>
                                                                    </div>
                                                                </td>
                                                            </tr>)}
                                                    </Draggable>
                                                })}
                                            </tbody>)}
                                    </Droppable>
                                </DragDropContext>
                            </table>
                        </div> :
                        <div className="mb-3">
                            <div className="d-flex mb-3">
                                <div className="mt-1 me-2">
                                    <FontAwesomeIcon type={'solid'} icon={'file'} iconClass={'me-2'} />
                                </div>
                                <div>
                                    <p className="mb-1"><strong>Name Your Rule :</strong></p>
                                    <p className="mb-0">Give your rule a name</p>
                                </div>
                            </div>
                            <div className="d-flex mb-3">
                                <div className="mt-1 me-2">
                                    <FontAwesomeIcon type={'solid'} icon={'plus'} iconClass={'me-2'} />
                                </div>
                                <div>
                                    <p className="mb-1"><strong>Choose The Trigger:</strong></p>
                                    <p className="mb-0">Select the trigger for which you want to perform your action. Such as Collection, network, hashtag, handle etc.</p>
                                </div>
                            </div>
                            <div className="d-flex">
                                <div className="mt-1 me-2">
                                    <FontAwesomeIcon type={'solid'} icon={'plus'} iconClass={'me-2'} />
                                </div>
                                <div>
                                    <p className="mb-1"><strong>Select your choice to create rule</strong></p>
                                    <p className="mb-0">Select the trigger for which you want to perform your action. Such as Collection, network, hashtag, handle etc.</p>
                                </div>
                            </div>
                        </div>}
                    <div className='mb-4 d-flex align-items-center'>
                        <span className='me-1 fs-5'>💡</span>
                        <span>Top-ranked rules take highest priority and override previous ones.</span>
                    </div>
                    {!ruleId ? <>
                        <h6 className="border-bottom mb-3 pb-3">Here's Default Rules List</h6>
                        <div className="">
                            {defaultRules.map((defaultRule, index) => {
                                const type = defaultRule.name.includes('Negativity') ? 2 : 1;
                                const enablePlan = trueSenseEnable;

                                //hide effortless approval for widget because ai score are not updated in widget.
                                const hideSection = (getInitialRoute() == 'widget' && defaultRule.name.includes('Effortless')) ? false : true;
                                return hideSection && <div className="rules-card mb-3" key={`default-rule-${index}`} style={defaultRule.isRuleUsed ? { opacity: 0.6, cursor: 'not-allowed' } : {}}>
                                    <div className="d-flex justify-content-between">
                                        <div className="mb-2 d-flex align-items-center">
                                            <div className="f-center rounded symbol-20 bg-dark me-2">
                                                <Image src={defaultRule.icon} height="16" width="16" />
                                            </div>
                                            <p className="m-0"><strong>{defaultRule.name}</strong></p>
                                        </div>
                                        {enablePlan ? <p className="mb-0 d-flex align-items-center">
                                            Enable
                                            <span className="switch custom-toggle ms-2">
                                                <CheckBoxField isChecked={defaultRule.value} name={`defaultOption-${index}`} id={`defaultOption-${index}`} onChangeHandler={!defaultRule.isRuleUsed ? (e) => selectDefaultRule(index) : null} text={''} />
                                            </span>
                                        </p> : <div className="">
                                            <button className="btn btn-link text-gradient text-nowrap p-0" type="button" onClick={() => upgradePlan(type)}>Upgrade Plan</button>
                                        </div>}
                                    </div>
                                    <div style={{ fontSize: '12px' }}>{defaultRule.description}</div>
                                </div>
                            })}
                        </div>
                    </> : null}
                </div>
            </div>
        </div>
    }
}

export default AutoModerationSidebar;